/**
 * Recharge Subscription Widget v2 mounts markup inside a ShadowRoot.
 * Theme stylesheets cannot pierce shadow DOM — inject rules into the shadow root
 * that contains `.rc-selection__root`.
 */
(function () {
  const MARK = 'data-pj-recharge-theme';
  const STYLE_VERSION = '9';

  const BASE_CSS = `
  .rc-selection__root {
    --rc-widget-brand-color: #4bf062 !important;
    --rc-widget-brand-color-50: rgba(75, 240, 98, 0.45) !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 0.5rem !important;
    max-width: 100% !important;
    padding-top: 0.4rem !important;
    width: 100% !important;
    font-family: var(--font-body-family, 'Work Sans', sans-serif) !important;
  }
  .rc-purchase-option {
    border: 1px solid #e0e0dc !important;
    border-radius: 0.75rem !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    min-height: 0 !important;
    overflow: visible !important;
    padding: 0.95rem 1rem 1rem 1rem !important;
    position: relative !important;
  }
  .rc-purchase-option[rc-selected] {
    background: #f2f2f0 !important;
    border-color: rgba(0, 0, 0, 0.08) !important;
  }
  .rc-purchase-option[rc-not-selected] {
    background: #fff !important;
    border-color: #e0e0dc !important;
  }
  .rc-purchase-option__subscription .rc-purchase-option__badge {
    background: #4bf062 !important;
    border: none !important;
    border-radius: 999px !important;
    box-shadow: none !important;
    color: #111 !important;
    font-family: var(--font-body-family, 'Work Sans', sans-serif) !important;
    font-size: clamp(0.55rem, 1.75vw, 0.62rem) !important;
    font-weight: 800 !important;
    letter-spacing: 0.06em !important;
    line-height: 1.2 !important;
    padding: 0.26rem 0.4rem !important;
    position: absolute !important;
    right: 0.65rem !important;
    text-transform: uppercase !important;
    top: 0 !important;
    transform: translateY(-50%) !important;
    z-index: 3 !important;
  }
  /* One row: title+radios | prices — grid keeps prices on the same row as the heading */
  .rc-purchase-option__label {
    -webkit-tap-highlight-color: transparent !important;
    align-items: center !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    column-gap: 0.65rem !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto !important;
    margin: 0 !important;
    padding: 0 !important;
    row-gap: 0.25rem !important;
    width: 100% !important;
  }
  .rc-purchase-option__label:focus-within {
    outline: none !important;
  }
  .rc-purchase-option__label:active {
    background: transparent !important;
  }
  /* Leave room for badge so prices don’t slide under it */
  .rc-purchase-option__subscription .rc-purchase-option__label {
    padding-right: 6.35rem !important;
  }
  .rc-purchase-option__selector {
    align-items: center !important;
    align-self: center !important;
    background: transparent !important;
    box-shadow: none !important;
    color: #111 !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    font-family: var(--font-body-family, 'Work Sans', sans-serif) !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    gap: 0.45rem !important;
    grid-column: 1 !important;
    line-height: 1.2 !important;
    margin: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
  }
  .rc-purchase-option__prices {
    align-items: baseline !important;
    align-self: center !important;
    display: flex !important;
    flex-direction: row !important;
    flex-shrink: 1 !important;
    flex-wrap: nowrap !important;
    font-size: 0 !important;
    gap: 0.5rem !important;
    grid-column: 2 !important;
    justify-content: flex-end !important;
    justify-self: end !important;
    line-height: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
    min-width: 0 !important;
    position: relative !important;
    white-space: nowrap !important;
    z-index: 1 !important;
  }
  /* Recharge ships a11y labels that sometimes render visually in shadow — hide for real */
  .rc-purchase-option__prices .visually-hidden,
  .rc-purchase-option__prices [class*='visually-hidden'] {
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;
    width: 1px !important;
  }
  .rc-purchase-option__prices .rc-price,
  .rc-purchase-option__prices span:not(.visually-hidden):not([class*='visually-hidden']) {
    flex: 0 1 auto !important;
    margin: 0 !important;
    position: static !important;
    inset: auto !important;
    transform: none !important;
  }
  .rc-price.strike-through,
  .rc-price.text-muted {
    color: #9a9a96 !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
    text-decoration: line-through !important;
  }
  .rc-purchase-option__prices > .rc-price:not(.strike-through):not(.text-muted) {
    color: #111 !important;
    font-size: 18px !important;
    font-weight: 800 !important;
    line-height: 1.2 !important;
  }
  .rc-purchase-option__sub-container {
    align-items: flex-start !important;
    display: flex !important;
    flex-direction: column !important;
    flex: 0 1 auto !important;
    gap: 0.7rem !important;
    margin-bottom: 0 !important;
    margin-top: 0.65rem !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
    padding-bottom: 0 !important;
    width: 100% !important;
  }
  .rc-purchase-option__sub-container rc-selling-plans {
    margin-bottom: 0 !important;
  }
  rc-selling-plans {
    box-sizing: border-box !important;
    display: block !important;
    max-width: 100% !important;
    min-width: 0 !important;
    width: max-content !important;
  }
  rc-learn-more {
    display: none !important;
  }
  rc-benefits::part(rc-benefits__list) {
    --rc-widget-bullet-icon-image-color: #4bf062;
    /* Tiny dot in viewBox so when Recharge scales the icon with list font-size, the bullet stays small */
    --rc-widget-bullet-icon-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Ccircle cx='2' cy='2' r='0.75' fill='%234bf062'/%3E%3C/svg%3E");
    color: #111 !important;
    font-size: 15px !important;
    font-weight: 400 !important;
    line-height: 1.35 !important;
    margin: 0 !important;
    padding-top: 0.1rem !important;
  }
  rc-selling-plans::part(rc-plans__label) {
    display: none !important;
  }
  rc-selling-plans::part(rc-plans-dropdown) {
    box-sizing: border-box !important;
    display: inline-block !important;
    margin: 0 !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 0 !important;
    vertical-align: top !important;
    width: auto !important;
  }
  rc-selling-plans::part(rc-plans-select) {
    -webkit-appearance: none !important;
    appearance: none !important;
    background: rgba(75, 240, 98, 0.2) !important;
    border: none !important;
    border-radius: 999px !important;
    box-sizing: border-box !important;
    color: #111 !important;
    cursor: pointer !important;
    font-family: var(--font-body-family, 'Work Sans', sans-serif) !important;
    font-size: 0.8125rem !important;
    font-weight: 600 !important;
    line-height: 1.35 !important;
    margin: 0 !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 0.52rem 2.2rem 0.52rem 0.9rem !important;
    width: auto !important;
  }
  rc-selling-plans::part(rc-plans-select):focus {
    outline: 2px solid rgba(75, 240, 98, 0.6) !important;
    outline-offset: 2px !important;
  }
  `;

  function injectIntoShadow(shadowRoot) {
    if (!shadowRoot || !shadowRoot.querySelector('.rc-selection__root')) return;
    if (shadowRoot.querySelector(`style[${MARK}="${STYLE_VERSION}"]`)) return;
    shadowRoot.querySelectorAll(`style[${MARK}]`).forEach((el) => el.remove());
    const style = document.createElement('style');
    style.setAttribute(MARK, STYLE_VERSION);
    style.textContent = BASE_CSS;
    shadowRoot.appendChild(style);
  }

  function scan(root) {
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) {
        injectIntoShadow(el.shadowRoot);
        scan(el.shadowRoot);
      }
    });
  }

  function run() {
    scan(document.documentElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  let t;
  const mo = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(run, 80);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
